import React, { useState, useEffect } from "react";
import SlidePanel from "../add_customer/SlidePanel";
import { X } from "lucide-react";

const NewEmail = ({
  id_R,
  isNewEmailOpen,
  setIsNewEmailOpen,
  newEmail,
  setNewEmail,
  handleCloseNewEmail,
  customerEditDetails,
  setEmailPromptOpen,
}) => {
  const [isEmailValid, setIsEmailValid] = useState(false);

  useEffect(() => {
    if (isNewEmailOpen) {
      setNewEmail(customerEditDetails?.email || "");
    }
  }, [isNewEmailOpen, customerEditDetails, setNewEmail]);

  useEffect(() => {
    const validateEmailStrict = (email) => {
      if (!email) return false;

      const cleanedEmail = email?.trim()?.toLowerCase();

      const basicRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!basicRegex?.test(cleanedEmail)) return false;

      const allowedTlds = [
        "com",
        "org",
        "io",
        "co.ke",
        "ac.ke",
        "ac.rw",
        "net",
      ];

      const domainPart = cleanedEmail?.split("@")[1];

      return allowedTlds?.some((tld) => domainPart?.endsWith(`.${tld}`));
    };

    setIsEmailValid(validateEmailStrict(newEmail));
  }, [newEmail]);

  const handleClose = () => {
    setIsNewEmailOpen(false);
  };

  const handleBackButton = () => {
    handleClose();
    setEmailPromptOpen(true);
  };

  return (
    <SlidePanel isOpen={isNewEmailOpen} onClose={handleClose}>
      <div className="relative flex flex-col h-full bg-white rounded-[12px]">
        <div
          onClick={handleClose}
          className="absolute top-0 right-0 cursor-pointer h-[40px] w-[40px] bg-[#FF0000] rounded-tr-[10px] rounded-bl-[20px] flex items-center justify-center z-10"
        >
          <X color="#ffffff" />
        </div>
        <div className="flex flex-col h-full">
          <div className="p-5">
            <div className="flex items-center">
              <p className="text-[20px] font-bold text-[#000] mt-8">
                Enter new email
              </p>
            </div>

            <p className="text-[#000] text-[15px] mt-5">
              Please enter the member’s new primary email for the verification
              process.
            </p>

            <div className="flex flex-col h-[50vh] mt-12">
              <div className="flex w-[98%] flex-col">
                <label htmlFor="firstname" className="mb-5">
                  Email
                </label>
                <div className="flex items-center gap-[15px]">
                  <input
                    type="text"
                    value={newEmail}
                    onChange={(e) => setNewEmail(e.target.value)}
                    className={`w-full rounded  px-3 py-3 bg-[#EAEAEA] border focus:outline-none ${
                      newEmail && !isEmailValid
                        ? "border-red-500"
                        : "border-[#EAEAEA]"
                    }`}
                  />
                </div>

                {newEmail && !isEmailValid && (
                  <p className="text-red-500 text-[13px] mt-2">
                    Please enter a valid email address.
                  </p>
                )}
              </div>
            </div>

            <div className="flex items-center w-full mx-auto text-white justify-between">
              <button
                onClick={handleBackButton}
                className="h-[50px] w-[175px] bg-[#7FB8EA] rounded-[5px] text-[#000]"
              >
                Back
              </button>

              <button
                onClick={handleCloseNewEmail}
                className={`h-[50px] w-[175px] rounded-[5px] text-[#FFFFFF] transition-all duration-200 ${
                  isEmailValid
                    ? "bg-[#074073] cursor-pointer"
                    : "bg-[#D9D9D9] cursor-not-allowed"
                }`}
                disabled={!isEmailValid}
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      </div>
    </SlidePanel>
  );
};

export default NewEmail;
